import { REDUCE_SIDEBAR } from "./actionTypes";

export const handleReduceSideBar = (data: any) => ({
  type: REDUCE_SIDEBAR,
  payload: data,
});
